<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Faqs" :submit="submit"
    :status="status" :breadcrumbs="[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/faqs'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <div class="label-base pb-1">Pregunta</div>
              <ValidationProvider ref="question" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.question" solo placeholder="Pregunta"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col>
              <div class="label-base pb-1">Respuesta</div>
              <ValidationProvider ref="answer" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.answer" solo placeholder="Respuesta"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col>
              <ValidationProvider ref="answer" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipos</div>
                <v-select :items="types" :error-messages="errors" multiple v-model="data.type" solo hide-details="auto"
                  class="input-base" append-icon="$caretDownFormIcon" />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: (state) => state.Faqs.status,
      types: (state) => state.Faqs.types,
    }),
  },
  data() {
    return {
      storeName: "Faqs",
      title: "FAQ's",
      data: {
        question: "",
        answer: "",
        type: "",
      },
    };
  },
};
</script>
